var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileWithoutExtensionSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#3859C5",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 495.429 495.429",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M439.086,177.286h-11.657v-57.314c0-0.486,0-0.486,0-0.972c0-2.429-0.972-4.372-2.429-6.314L329.314,3.4l0,0 c-0.485-0.485-1.457-0.971-1.942-1.457l-0.486-0.486c-0.485-0.485-1.457-0.485-1.942-0.971h-0.486C323.972,0.486,323,0,322.028,0 h-234.6C76.743,0,68,8.743,68,19.429v157.857H56.343c-15.543,0-27.686,12.629-27.686,27.686v144.257 c0,15.543,12.629,27.686,27.686,27.686H68V476c0,10.686,8.743,19.429,19.429,19.429H408c10.686,0,19.429-8.743,19.429-19.429v-98.6 h11.657c15.543,0,27.686-12.629,27.686-27.686V204.972C466.771,189.915,454.629,177.286,439.086,177.286z M87.429,19.429h224.886 V119c0,5.343,4.371,9.714,9.714,9.714H408v48.571H87.429V19.429L87.429,19.429z M408,471.143H87.429V377.4H408V471.143z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileWithoutExtensionSvgrepoCom);
export default __webpack_public_path__ + "static/media/file-without-extension-svgrepo-com.ec1d6100450e2340ea0131208373ed19.svg";
export { ForwardRef as ReactComponent };